<script setup lang="ts">
import { mainNavigationMedicalSystems, mainNavigationQaEquipment } from '@/components/icons/icons';
import ScopeList from '@/views/enumerations/components/ScopeList.vue';
import ScopeGroups from '@/views/enumerations/components/ScopeGroups.vue';
import { useScopeOptions } from '@/components/quantitiesAndUnits/quantitiesAndUnitsUtils';
import { onMounted } from 'vue';
import FormSection from '@/components/forms/FormSection/FormSection.vue';

withDefaults(
  defineProps<{
    name: string;
    disabled?: boolean;
    allowExtend: boolean;
  }>(),
  {
    disabled: false,
  },
);

const { load, options } = useScopeOptions();

onMounted(async () => {
  await load();
});
</script>

<template>
  <FormSection :disabled="disabled && !allowExtend">
    <v-card class="container-level-1"
      ><v-card-item
        ><v-card-title>
          <h5>{{ $t('UseInSetupCategory_other') }}</h5>
        </v-card-title></v-card-item
      ><v-card-text>
        <!-- medical system scope -->
        <v-label>
          <v-icon
            size="40"
            class="mr-2 text-primary-darken-2"
            :icon="mainNavigationMedicalSystems"
          />
          <h6 class="text-h6 text-primary-darken-2">
            {{ $t('MedicalSystems') }}
          </h6>
        </v-label>

        <ScopeGroups
          :name="`${name}.medicalSystemScope`"
          :scopeOptions="options.medicalSystems"
          scopeKey="rtSystemSubCategory"
          groupKey="rtSystemCategory"
          :disabled="disabled"
          :disableSettedOptions="allowExtend" />

        <v-divider class="my-6"></v-divider>

        <!-- dosimetry and qa qaEquipment -->
        <v-label>
          <v-icon size="40" class="mr-2 text-primary-darken-2" :icon="mainNavigationQaEquipment" />
          <h6 class="text-h6 text-primary-darken-2">
            {{ $t('DosimetryAndQaEquipment') }}
          </h6>
        </v-label>

        <ScopeList
          :name="`${name}.qaEquipmentScope`"
          :scopeOptions="options.qaEquipment"
          scopeKey="rtSystemSubCategory"
          :disabled="disabled"
          :disableSettedOptions="allowExtend" /></v-card-text
    ></v-card>
  </FormSection>
</template>
